import { useState } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { AuthModal } from './AuthModal';
import { NotificationBell } from '../notification/NotificationBell';

export function Header() {
  const { isLoggedIn, isAdmin, logout } = useAuthStore();
  const [showAuth, setShowAuth] = useState(false);

  return (
    <header className="bg-white/80 backdrop-blur-md border-b sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.location.href = '/?mode=library'}>
          <span className="text-2xl">📚</span>
          <h1 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            3D 绘本工厂
          </h1>
        </div>
        <nav className="flex items-center gap-4">
          {isLoggedIn ? (
            <div className="flex items-center gap-3">
              <a href="/?mode=ai-generator" className="text-sm text-gray-600 hover:text-gray-900">🎨 AI 创作</a>
              <a href="/?mode=ai-history" className="text-sm text-gray-600 hover:text-gray-900">📜 AI 历史</a>
              <a href="/?mode=account" className="text-sm text-gray-600 hover:text-gray-900">我的账户</a>
              <a href="/?mode=children" className="text-sm text-gray-600 hover:text-gray-900">👨‍👩‍👧‍👦 孩子档案</a>
              <a href="/?mode=parent" className="text-sm text-gray-600 hover:text-gray-900">📊 家长看板</a>
              {isAdmin && <a href="/?mode=admin" className="text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded-full">管理后台</a>}
              <NotificationBell />
              <button onClick={logout}
                className="text-sm text-gray-500 hover:text-gray-700 transition">退出</button>
            </div>
          ) : (
            <button onClick={() => setShowAuth(true)}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition">
              登录 / 注册
            </button>
          )}
        </nav>
      </div>
      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </header>
  );
}
